<template>
  <span>{{hour}}:{{minute}}:{{second}}</span>
</template>

<script>
let timer
export default {
  data() {
    return {
      time: 0,
    }
  },
  props: {
    date: {
      type: null,
      required: true,
    },
    offset: {
      type: Number,
      default() {
        return 48 * 60 * 60 * 1000
      },
    },
  },
  computed: {
    hour() {
      const hours = Math.floor(this.time / 1000 / 60 / 60 % 24)
      return hours > 9 ? hours : '0' + hours
    },
    minute() {
      const minutes = Math.floor(this.time / 1000 / 60 % 60)
      return minutes > 9 ? minutes : '0' + minutes
    },
    second() {
      const seconds = Math.floor(this.time / 1000 % 60)
      return seconds > 9 ? seconds : '0' + seconds
    },
  },
  created() {
    this.time = (new Date(this.date)).getTime() + this.offset - Date.now()
    timer = window.setInterval(() => {
      if (this.time < 1) {
        return window.clearInterval(timer)
      }
      this.time = (new Date(this.date)).getTime() + this.offset - Date.now()
    }, 1000)
  },
  beforeDestroy() {
    window.clearInterval(timer)
  },
}
</script>



// WEBPACK FOOTER //
// Countdown.vue?e8253f76